import { WizardComponent } from "ng2-archwizard";
import { Component, OnInit, ViewChild } from "@angular/core";
import { FormGroup, FormControl, FormArray } from "@angular/forms";
import { MovingDirection } from "ng2-archwizard";

import { CommerceService } from "../../core/service/app/commerce.service";
import { AccountService } from "../../core/service/app/account.service";
import { Store } from "@ngrx/store";
import { AppState } from "../../store/app-state";
import { FacebookService } from "ngx-facebook";
import { DialogService } from "ng2-bootstrap-modal";
import { ToastrService } from "ngx-toastr";
import { RouterService } from "app/core/service/core/router.sevice";
import swal from "sweetalert2";
import { loadingService } from "app/core/service/loading.service";
import { DebugContext } from "@angular/core/src/view";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"]
})
export class HomePageComponent implements OnInit
{
  @ViewChild(WizardComponent) public wizardComp: WizardComponent;

  email = ""
  password = "";


  wizard = {
    id: 0,
    step: 1
  };
  commerceSat: object;

  step = 1;
  tmpRegisterId: number = 0;
  idTipoPersona: number = 0;

  isLogin = false;

  va;

  form: FormGroup;
  formArray: FormArray;


  porcent = 50;
  postalCode: string = "0";

  userID = 0;
  isAuth = false;
  forwardOnes = true;
  totalAmount = 0;

  //Valores para Confirmar correo
  code: string = "";
  private sub: any;
  

  toggleLogin() {
    this.isLogin = !this.isLogin;
  }

  constructor(
    private store: Store<AppState>,
    private commerceService: CommerceService,
    private accountService: AccountService,
    private dialogService: DialogService,
    private toastrService: ToastrService,
    private fb: FacebookService,
    private route: RouterService,
    private loadingservice: loadingService,
    private activateRoute: ActivatedRoute

  ) {
    this.store.subscribe(state => {
      this.isAuth = state.user.isAuth;
      if (state.user.data && state.user.data.id && this.userID == 0) {
        this.userID = state.user.data.id;
        this.step = 4;
        this.form.patchValue({ userID: this.userID, step: 1 });
        this.getWizard(this.userID);
      }
    });
  }

  isPaso2Valid = false;
  isPaso4Valid = false;

  
  paso2Valido(event){
    this.isPaso2Valid = event;
  }

  paso4Valido(event){
    this.isPaso4Valid = event;
  }

  getWizard(userID)
  {
    this.commerceService.getWizard(userID).then(result => {
      if (result != null) {
        this.commerceService.setTitulo(result.register.commerceName)
        this.wizard.id = result.id;
        this.wizard.step = result.step;
        this.commerceService.wizard.id = result.id;
        this.commerceSat = result.commerceSat;

        if (this.forwardOnes) {
          this.forwardOnes = false;
          for (var i = 0; i < this.wizard.step; i++) {
            this.wizardComp.goToStep(i);
            this.commerceService.wizard.step = i + 1;
          }
        }

        if (result) {          
          this.idTipoPersona = result.register.legalStructure;
          this.form.patchValue({ appointment : result.appointment });
          this.form.patchValue({ finance : result.finance });
          this.form.patchValue({ general : result.general });
          this.form.patchValue({ offer : result.offer });
          this.form.patchValue({ register : result.register });
          this.form.patchValue({ registerR : result.register });
          this.form.patchValue({ sat : result.sat });
          this.totalAmount = result.offer.montoDesembolsar;
        }
      }
      
    });
  }

  goback() {
    window.scrollTo(0, 0);
    this.commerceService.wizard.step = this.wizardComp.currentStepIndex + 1;
    this.commerceService.saveWizardData().then(result => 
    {
      this.getWizard(this.userID);
      /*if (result) 
      {
        this.idTipoPersona = result.register.legalStructure;
        
        this.form.patchValue({ appointment : result.appointment });
        this.form.patchValue({ finance : result.finance });
        this.form.patchValue({ general : result.general });
        this.form.patchValue({ offer : result.offer });
        this.form.patchValue({ register : result.register });
        this.form.patchValue({ registerR : result.register });
        this.form.patchValue({ sat : result.sat });
        this.totalAmount = result.offer.montoDesembolsar;
      }*/
    });
  }

  goStep(step) 
  {
    window.scrollTo(0, 0);
    this.wizardComp.goToStep(step);
    this.commerceService.wizard.step = this.wizardComp.currentStepIndex + 1;
    this.commerceService.saveWizardData().then(result => 
    {
      this.getWizard(this.userID);
      /*if (result!=undefined)
      {
        this.form.patchValue({ appointment : result.appointment });
        this.form.patchValue({ finance : result.finance });
        this.form.patchValue({ general : result.general });
        this.form.patchValue({ offer : result.offer });
        this.form.patchValue({ register : result.register });
        this.form.patchValue({ registerR : result.register });
        this.form.patchValue({ sat : result.sat });
        this.totalAmount = result.offer.montoDesembolsar;
      }*/
    });
  }

  finishWizard() {
    this.commerceService.saveWizardData().then(result => 
    {
      if (result) 
      {
        this.idTipoPersona = result.register.legalStructure;
        this.form.patchValue({ appointment : result.appointment });
        this.form.patchValue({ finance : result.finance });
        this.form.patchValue({ general : result.general });
        this.form.patchValue({ offer : result.offer });
        this.form.patchValue({ register : result.register });
        this.form.patchValue({ registerR : result.register });
        this.form.patchValue({ sat : result.sat });
        this.totalAmount = result.offer.montoDesembolsar;
      }
    });
    this.route.go('/fin');
    
  }

  ngOnInit() {
    
    window.scrollTo(0, 30);

    this.form = new FormGroup({
      id: new FormControl(0),
      userID: new FormControl(0),
      step: new FormControl(0),
      fase: new FormControl(0),
      faseEstatus: new FormControl(0),
      contratoID: new FormControl(0),
      fechaAlta: new FormControl(''),
      estatus: new FormControl(),
      identificador: new FormControl(0),
      
    });

    this.formArray = new  FormArray([]);

    this.sub = this.activateRoute.params.subscribe(params => {
      this.code = params['code'];
      if(this.code == ""){
          this.route.go("/");
      }
    });


    this.form.statusChanges.subscribe(value => {
      if (this.userID > 0) {
        this.commerceService.saveWizard(
          Object.assign(
            {},
            { 
              userId: this.userID,
              step: this.wizardComp.currentStepIndex 
            },
            this.form.value
          )
        );
      }
    });
    this.commerceService.disket.subscribe(result =>{
      this.form.patchValue(
        {
          id: result.id,
          fechaAlta: result.fechaAlta,
          identificador: result.identificador,
          estatus: result.estatus,
          fase: result.fase,
      });
    })
  }

  completeForm() {
    if (this.step === 1) {
      if (this.form.value.register.postalCode) {
        this.postalCode = this.form.value.register.postalCode;
      }
    }
    this.next();

    if (this.step === 5) {
      //this.comme  rceService.saveAll(this.form.value);
      //alert('GUARDAR TOOODOO');
    }
  }


  savePage1(data) {
    this.commerceService.setPage1(data);
    
    this.commerceService.saveFase1(data).then(result => {
      this.tmpRegisterId = result;
    });

    this.completeForm();
    this.form.patchValue({
      general: {
        personMoral: {
          socialRazon: data.commerceName
        }
      }
    })

  }
  savePage2(data) {
    this.form.get("register").patchValue(this.form.get("offer").value);
    data.id = this.tmpRegisterId;
    this.commerceService.saveFase2(data);

    this.totalAmount = data.total;
    this.commerceService.setPage2(data.total);
    this.completeForm();
  }
  savePage3(data) {
    data.id = this.tmpRegisterId;
    this.commerceService.saveFase3(data);
    this.commerceService.setPage3(data);
    //this.completeForm();
  }

  prev() {
    this.step--;
  }
  next() {
    this.step++;
  }

  stepOneValid = (movingDirection: MovingDirection) => {
    const form = this.form.get("general");
    if (form.valid && !this.isAuth) {
      const email = form.value.user_email;
      const password = form.value.user_password;
      this.accountService.login({ email, password }).then(result => {
        if (!result) {
          this.accountService
            .register({ email, password, passwordRepeat: password })
            .then(result => {
              this.accountService.login({ email, password });
            });
        }
      });
    }
    window.scrollTo(0, 0);
    return movingDirection === MovingDirection.Backwards || form.valid;
  };
  stepTwoValid = (movingDirection: MovingDirection) => {
    return (
      movingDirection === MovingDirection.Backwards ||
      this.form.get("finance").valid
    );
  };

  validarPaso1()
  {
    var valid = true;
    let general = this.form.get("general");
    if(general)
    {
      if(general.get("street").value == null || general.get("street").value == ""){ valid = false; }
      if(general.get("colony").value == null || general.get("colony").value == ""){ valid = false; }

      let references = general.get("references");
      if(references)
      {
        if(references.get("referenceA").get("name").value == null || references.get("referenceA").get("name").value == ""){ valid = false; }
        if(references.get("referenceB").get("name").value == null || references.get("referenceB").get("name").value == ""){ valid = false; }
      }

      let person = general.get("personMoral");
      if(person)
      {
        //if(person.get("socialRazon").value == null || person.get("socialRazon").value == ""){ valid = false; }
        if(person.get("dateConstitution").value == null || person.get("dateConstitution").value == ""){ valid = false; }
        if(person.get("rfc").value == null || person.get("rfc").value == ""){ valid = false; }
      }
    }
    if(valid == true)
    {
      this.goStep(1);
    }
    else{
      swal({ title: "Información Incompleta", type: "warning", text: "Favor de completar la información solicitada" });
    }
  }

  validarPaso2()
  {
    this.goStep(2);
    /*if(this.isPaso2Valid == true)
    {
      this.goStep(2);
    }
    else
    {
      swal({ title: "Información Incompleta", type: "warning", text: "Favor de cargar todos los estados de cuenta" });
    }*/
  }

  validarPaso4()
  {
    this.goStep(3)

    /*if(this.isPaso4Valid== true)
    {
      this.goStep(3);
    }
    else
    {
      swal({ title: "Información Incompleta", type: "warning", text: "Favor de completar el Expediente Digital"});
    }*/
  }

  Ingresar(){
    this.accountService.login({email : this.email, password: this.password})
    .then(result => {
      if (result != undefined) {
        switch(result.error)
        {
          case "user_dont_validate":
            swal({
              type: 'error',
              title: 'Credenciales Incorrectas',
              text: 'Contraseña Incorrecta'
            })
            break;
            case "user_dont_exist":
              swal({
                type: 'error',
                title: 'Credenciales incorrectas',
                text: 'El usuario no Existe o la contraseña es Incorrecta'
              })
            break;
        }
      }
    });
  }

  recover() {
    swal({
      type: "question" ,
      title: 'Recuperación de Contraseña',
      text: 'Favor de escribir el correo asociado al comercio',
      input: "text"
    }).then(email => {
      if(email.value != "")
      {
        this.accountService.sendCode(email.value)
        .then(result => {
          if (result) {
            swal({
              type: 'success',
              title: 'Proceso completo',
              text: 'Favor revisar su correo, se enviaron las instrucciones para recuperar su contraseña.'
            })
          } else {
            swal({
              type: 'error',
              title: 'Disculpe las molestias',
              text: 'El correo indicado no esta asociado a ningun comercio, Favor de Validar o iniciar su registro en Anticipa.com.mx',
            })
          }
        })
      }
      else{
        swal({
          type: 'warning',
          title: 'Faltan Datos',
          text: 'Favor de escribir el correo asociado con el Comercio'
        });
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/page/home-page/home-page.component.ts